module.exports = __webpack_public_path__ + "static/media/billiards.08565dcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/billiards.svg
// module id = 1417
// module chunks = 0